(function () {
  'use strict';

  function initGallery(root) {
    var main = root.querySelector('[data-bv-main-image]');
    var thumbs = root.querySelectorAll('[data-bv-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-bv-thumb');
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  function initVariants(root) {
    var box = root.querySelector('[data-bv-selectors]') || root.querySelector('.bv-offer-selectors');
    if (!box) return;

    var map;
    try {
      map = JSON.parse(box.getAttribute('data-bv-variants'));
    } catch (e) {
      return;
    }

    var idInput = root.querySelector('[data-bv-id]');
    var priceEl = root.querySelector('[data-bv-price]');
    var cta = root.querySelector('[data-bv-cta]');
    var ctaText = root.querySelector('[data-bv-cta-text]');
    var sold = root.querySelector('[data-bv-sold]');
    var lensName = root.querySelector('[data-bv-lens-name]');
    var strapName = root.querySelector('[data-bv-strap-name]');
    var lensBtns = root.querySelectorAll('[data-bv-lens-btn]');
    var strapBtns = root.querySelectorAll('[data-bv-strap-btn]');

    var state = {
      lens: box.getAttribute('data-bv-lens') || '',
      strap: box.getAttribute('data-bv-strap') || ''
    };
    var defaultCta = ctaText ? ctaText.textContent : '';

    function variantFor(lens, strap) {
      return map[lens + '|' + strap] || null;
    }

    function render() {
      lensBtns.forEach(function (btn) {
        var val = btn.getAttribute('data-bv-lens-btn');
        var v = variantFor(val, state.strap);
        btn.classList.toggle('is-active', val === state.lens);
        btn.classList.toggle('is-off', !v || !v.a);
      });

      strapBtns.forEach(function (btn) {
        var val = btn.getAttribute('data-bv-strap-btn');
        var v = variantFor(state.lens, val);
        btn.classList.toggle('is-active', val === state.strap);
        btn.classList.toggle('is-off', !v || !v.a);
      });

      var current = variantFor(state.lens, state.strap);
      var available = !!(current && current.a);

      if (idInput && current) idInput.value = current.id;
      if (priceEl && current && current.p) priceEl.innerHTML = current.p;

      if (lensName) lensName.textContent = titleize(state.lens);
      if (strapName) strapName.textContent = titleize(state.strap);

      if (cta) {
        cta.disabled = !available;
        cta.setAttribute('aria-disabled', available ? 'false' : 'true');
      }
      if (ctaText) ctaText.textContent = available ? defaultCta : 'Sold out';
      if (sold) sold.hidden = available;
    }

    function titleize(s) {
      if (!s) return '';
      return s.split('-').map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      }).join('-');
    }

    lensBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.lens = btn.getAttribute('data-bv-lens-btn');
        render();
      });
    });

    strapBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.strap = btn.getAttribute('data-bv-strap-btn');
        render();
      });
    });

    render();
  }

  function initScroll() {
    document.querySelectorAll('[data-bv-scroll]').forEach(function (link) {
      link.addEventListener('click', function (evt) {
        var target = document.querySelector('[data-bv-offer]');
        if (!target) return;
        evt.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    var offer = document.querySelector('[data-bv-offer]');
    if (offer) {
      initGallery(offer);
      initVariants(offer);
    }
    initScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();
